import PhoneCountryType from "@CheckOrder/types/PhoneCountry.type";

export const validatePhoneCountry = (phoneCountry: PhoneCountryType):boolean => (!!phoneCountry.name)